import announcementService from '../marketing/announcement.service';

const PLATFORM_NEWS_SESSION_KEY = '@facilita-app/platform-news-shown-session';

const markPlatformNewsShownInSession = () =>
    sessionStorage.setItem(PLATFORM_NEWS_SESSION_KEY, 'true');

const wasPlatformNewsShownInSession = () =>
    sessionStorage.getItem(PLATFORM_NEWS_SESSION_KEY) === 'true';

const isTabNews = (newsKey) => !!newsKey && !announcementService.isShowed(newsKey);

const registerTabVisit = (newsKey) => {

    if (!isTabNews(newsKey))
        return Promise.resolve(false);

    return announcementService.markViewed(newsKey).then(() => true);
}

export default { isTabNews, registerTabVisit, markPlatformNewsShownInSession, wasPlatformNewsShownInSession };
